import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "form-group mb-4 position-relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "form-group mb-4 position-relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-group mb-4 position-relative" }
const _hoisted_18 = ["type"]
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/account-settings",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Informations ", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-edit-password",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Changement de mot de passe ", -1)
                ])),
                _: 1,
                __: [8]
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "fw-semibold mb-10" }, "Mot de passe actuel", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showCurrent ? 'text' : 'password',
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userData.currentPassword) = $event)),
                    placeholder: "Mot de passe actuel"
                  }, null, 8, _hoisted_11), [
                    [_vModelDynamic, _ctx.userData.currentPassword]
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["ph", _ctx.showCurrent ? 'ph-eye-slash' : 'ph-eye']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCurrent = !_ctx.showCurrent)),
                    style: {"position":"absolute","right":"15px","top":"42px","cursor":"pointer"}
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "fw-semibold mb-10" }, "Nouveau mot de passe", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showNew ? 'text' : 'password',
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userData.newPassword) = $event)),
                    placeholder: "Nouveau mot de passe"
                  }, null, 8, _hoisted_14), [
                    [_vModelDynamic, _ctx.userData.newPassword]
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["ph", _ctx.showNew ? 'ph-eye-slash' : 'ph-eye']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNew = !_ctx.showNew)),
                    style: {"position":"absolute","right":"15px","top":"42px","cursor":"pointer"}
                  }, null, 2),
                  (_ctx.userData.newPassword && !_ctx.isPasswordValid)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_15, " Le mot de passe doit contenir au moins 8 caractères, un chiffre et un caractère spécial. "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "fw-semibold mb-10" }, "Confirmer le mot de passe", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showConfirm ? 'text' : 'password',
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.confirmNewPassword) = $event)),
                    placeholder: "Confirmation"
                  }, null, 8, _hoisted_18), [
                    [_vModelDynamic, _ctx.userData.confirmNewPassword]
                  ]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["ph", _ctx.showConfirm ? 'ph-eye-slash' : 'ph-eye']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConfirm = !_ctx.showConfirm)),
                    style: {"position":"absolute","right":"15px","top":"42px","cursor":"pointer"}
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                    type: "submit",
                    disabled: 
                      !_ctx.userData.currentPassword ||
                      !_ctx.userData.newPassword ||
                      !_ctx.userData.confirmNewPassword
                    
                  }, " Enregistrer les modifications ", 8, _hoisted_21)
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}